import React, { useEffect } from "react";
import CardColumn from "../../components/CardColumn";
import Footer from "../../components/Footer";
import Category from "../../components/Home/Category";
import styled from "styled-components";
import Header from "../../components/Navbar";
import Container from "../../UI/Container";
import CollectionCards from "../../components/CollectionCards";
import { UsePostsContext } from "../../store/contexts/posts.context";
import CategoryColumn from "../../components/Home/CategoryColumn";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";

function PostsPage() {
  const { getRecents, getLiked, getRated, getViewed, searchPosts } =
    UsePostsContext();
  const [posts, setposts] = useState();
  const [pag, setpag] = useState();
  const [searchParams] = useSearchParams();
  const [fn, setfn] = useState();
  const [title, settitle] = useState("");
  useEffect(() => {
    setpag(0);
  }, []);
  useEffect(() => {
    setpag(0);
    getPosts();
  }, [searchParams.get("category")]);
  useEffect(() => {
    setpag(0);
    getPosts();
  }, [searchParams.get("search")]);
  useEffect(() => {
    getPosts();
  }, [pag]);
  const getPosts = () => {
    const category = searchParams.get("category");
    const search = searchParams.get("search");
    if (category)
      switch (category) {
        case "recents": {
          const f = async () => {
            const res = await getRecents(pag, 6, true);
            setposts(res.data);
          };
          f();
          settitle("Most Recently");
          break;
        }
        case "liked": {
          const f = async () => {
            const res = await getLiked(pag, 6, true);
            setposts(res.data);
          };
          f();
          settitle("Most Liked");
          break;
        }
        case "rated": {
          const f = async () => {
            const res = await getRated(pag, 6, true);
            setposts(res.data);
          };
          f();
          settitle("Most Rated");
          break;
        }
        case "viewed":
          {
            const f = async () => {
              const res = await getViewed(pag, 6, true);
              setposts(res.data);
            };
            f();
            settitle("Most Viewed");
          }
          break;
        default: {
          const f = async () => {
            const res = await getRecents(pag, 6, true);
            setposts(res.data);
          };
          settitle("Most Recently");
          f();
        }
      }
    else if (search) {
      const f = async () => {
        const res = await searchPosts(pag, pag + 6, search);
        settitle("Search: " + search);
        setposts(res.data);
      };
      f();
    } else {
      const f = async () => {
        const res = await getRecents(pag, 6, true);
        setposts(res.data);
      };
      settitle("Most Recently");
      f();
    }
  };
  return (
    <div>
      <Header />
      <div className="devider"></div>
      <Category />
      <div className="devider"></div>
      {posts !== null ? (
        <Container>
          <h1 className="main-title">{title}</h1>
          <div className="devider"></div>
          <Wrapper>
            {posts && posts.map((i) => <CardColumn data={i} />)}
          </Wrapper>
          <div className="devider"></div>
          <Pagination className="flex">
            <div
              onClick={() => setpag(pag === 0 ? 0 : pag - 6)}
              style={{ opacity: pag === 0 ? "0.4" : "1" }}
            >
              <img src="https://img.icons8.com/external-dreamstale-lineal-dreamstale/32/undefined/external-left-arrows-dreamstale-lineal-dreamstale-10.png" />
              <span>Prev</span>
            </div>
            <div
              onClick={() => setpag(posts?.length === 6 ? pag + 6 : pag)}
              style={{ opacity: posts?.length === 6 ? "1" : "0.4" }}
            >
              <span>Next</span>
              <img src="https://img.icons8.com/external-dreamstale-lineal-dreamstale/32/undefined/external-right-arrows-dreamstale-lineal-dreamstale-8.png" />
            </div>
          </Pagination>
        </Container>
      ) : (
        <Container>
          {" "}
          <h1 className="main-title">No posts found!</h1>
        </Container>
      )}
      <div className="devider"></div>
      <Footer />
    </div>
  );
}

export default PostsPage;
const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 12px;
  @media (max-width: 991px) {
    grid-template-columns: 1fr 1fr !important;
  }
  @media (max-width: 767px) {
    grid-template-columns: 1fr !important;
    gap: 12px;
  }
`;

const Pagination = styled.div`
  gap: 40px;
  div {
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      cursor: pointer;
      span {
        width: 50px;
      }
    }
    img {
      transition: all 0.3s;
    }
    span {
      transition: all 0.3s;
      display: block;
      width: 0px;
      overflow: hidden;
    }
  }
  img {
    width: 20px !important;
    height: 20px !important;
  }
`;
